<div *ngIf="isOpen" class="fixed inset-0 z-50 overflow-y-auto bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 sm:p-4">
    <div class="relative bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden animate-fadeIn">
        
        <!-- Modal Header -->
        <div class="px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-gradient-to-r from-gray-50 to-white">
            <div class="flex items-center gap-3">
                <div class="w-10 h-10 rounded-xl bg-emerald-100 text-emerald-700 flex items-center justify-center shadow-inner">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                            d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path>
                    </svg>
                </div>
                <div>
                    <h2 class="text-lg font-bold text-gray-900">
                        {{ viewMode === 'list' ? 'Kelola Kategori Voucher' : (isEditMode ? 'Edit Kategori Voucher' : 'Tambah Kategori Voucher Baru') }}
                    </h2>
                    <p class="text-xs text-gray-500">
                        {{ viewMode === 'list' ? 'Atur daftar kategori yang dapat digunakan saat membuat voucher' : 'Isi formulir kategori voucher dengan lengkap' }}
                    </p>
                </div>
            </div>
            <button (click)="closeModal()" class="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
            </button>
        </div>

        <!-- Modal Body: LIST VIEW -->
        <div *ngIf="viewMode === 'list'" class="flex-1 flex flex-col overflow-hidden">
            <!-- Toolbar -->
            <div class="px-6 py-3 border-b border-gray-100 flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 bg-white">
                <div class="relative flex-1 max-w-md">
                    <input type="text" [(ngModel)]="searchTerm" placeholder="Cari nama, kode, atau deskripsi..."
                        class="w-full pl-9 pr-4 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none transition" />
                    <svg class="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                    </svg>
                </div>
                <div class="flex items-center gap-2">
                    <button (click)="loadCategories()" [disabled]="isLoading" title="Muat ulang data"
                        class="p-2 text-gray-500 hover:text-gray-800 hover:bg-gray-100 border border-gray-200 rounded-lg transition">
                        <svg class="w-4 h-4" [class.animate-spin]="isLoading" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                        </svg>
                    </button>
                    <button (click)="openCreateForm()"
                        class="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold rounded-lg transition-colors flex items-center gap-2 shadow-sm">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                        </svg>
                        Tambah Kategori
                    </button>
                </div>
            </div>

            <!-- Content Area -->
            <div class="flex-1 overflow-y-auto p-6">
                <!-- Loading State -->
                <div *ngIf="isLoading" class="flex flex-col items-center justify-center py-16 text-gray-400">
                    <svg class="w-8 h-8 animate-spin text-emerald-600 mb-2" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                    </svg>
                    <span class="text-sm">Memuat data kategori...</span>
                </div>

                <!-- Empty State -->
                <div *ngIf="!isLoading && filteredCategories.length === 0" class="text-center py-16">
                    <div class="w-16 h-16 mx-auto mb-3 bg-gray-100 rounded-full flex items-center justify-center text-gray-400">
                        <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path>
                        </svg>
                    </div>
                    <h3 class="text-base font-semibold text-gray-800">Tidak ada kategori ditemukan</h3>
                    <p class="text-xs text-gray-500 mt-1 max-w-sm mx-auto">
                        {{ searchTerm ? 'Coba ubah kata kunci pencarian Anda' : 'Belum ada kategori voucher yang dibuat. Silakan tambahkan kategori baru.' }}
                    </p>
                    <button *ngIf="!searchTerm" (click)="openCreateForm()"
                        class="mt-4 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-semibold rounded-lg inline-flex items-center gap-1.5 transition">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                        </svg>
                        Tambah Kategori Sekarang
                    </button>
                </div>

                <!-- Category Table -->
                <div *ngIf="!isLoading && filteredCategories.length > 0" class="border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                    <table class="min-w-full divide-y divide-gray-200 text-left text-sm">
                        <thead class="bg-gray-50 text-gray-600 font-semibold text-xs uppercase tracking-wider">
                            <tr>
                                <th class="px-4 py-3">Kategori</th>
                                <th class="px-4 py-3">Deskripsi</th>
                                <th class="px-3 py-3 text-center">Urutan</th>
                                <th class="px-3 py-3 text-center">Voucher</th>
                                <th class="px-4 py-3 text-center">Status</th>
                                <th class="px-4 py-3 text-right">Aksi</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-100 bg-white">
                            <tr *ngFor="let cat of filteredCategories" class="hover:bg-gray-50/80 transition-colors">
                                <!-- Name & Code -->
                                <td class="px-4 py-3.5">
                                    <div class="flex items-center gap-2.5">
                                        <span class="w-3.5 h-3.5 rounded-full flex-shrink-0 shadow-sm border border-black/10"
                                            [style.backgroundColor]="cat.color || '#3B82F6'"></span>
                                        <div>
                                            <div class="font-bold text-gray-900">{{ cat.name }}</div>
                                            <div class="text-xs font-mono text-gray-400">{{ cat.code }}</div>
                                        </div>
                                    </div>
                                </td>

                                <!-- Description -->
                                <td class="px-4 py-3.5 max-w-xs">
                                    <span class="text-xs text-gray-600 line-clamp-2" [title]="cat.description || ''">
                                        {{ cat.description || '-' }}
                                    </span>
                                </td>

                                <!-- Sort Order -->
                                <td class="px-3 py-3.5 text-center">
                                    <span class="inline-block px-2 py-0.5 text-xs font-semibold bg-gray-100 text-gray-700 rounded">
                                        {{ cat.sort_order ?? 0 }}
                                    </span>
                                </td>

                                <!-- Vouchers Count -->
                                <td class="px-3 py-3.5 text-center">
                                    <span class="inline-block px-2.5 py-0.5 text-xs font-medium rounded-full bg-blue-50 text-blue-700 border border-blue-100">
                                        {{ cat.vouchers_count || 0 }} voucher
                                    </span>
                                </td>

                                <!-- Status Toggle -->
                                <td class="px-4 py-3.5 text-center">
                                    <button (click)="toggleActive(cat)" [disabled]="isTogglingId === cat.id"
                                        class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold transition shadow-sm"
                                        [ngClass]="cat.is_active ? 'bg-emerald-100 text-emerald-800 hover:bg-emerald-200' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'"
                                        [title]="cat.is_active ? 'Klik untuk nonaktifkan' : 'Klik untuk aktifkan'">
                                        <span class="w-1.5 h-1.5 rounded-full" [ngClass]="cat.is_active ? 'bg-emerald-500' : 'bg-gray-400'"></span>
                                        {{ cat.is_active ? 'Aktif' : 'Nonaktif' }}
                                        <svg *ngIf="isTogglingId === cat.id" class="w-3 h-3 animate-spin ml-1" fill="none" viewBox="0 0 24 24">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                                        </svg>
                                    </button>
                                </td>

                                <!-- Actions -->
                                <td class="px-4 py-3.5 text-right">
                                    <div class="inline-flex items-center gap-1">
                                        <button (click)="openEditForm(cat)" title="Edit Kategori"
                                            class="p-1.5 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition">
                                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                                            </svg>
                                        </button>
                                        <button (click)="deleteCategory(cat)" [disabled]="isDeletingId === cat.id" title="Hapus Kategori"
                                            class="p-1.5 text-rose-600 hover:text-rose-800 hover:bg-rose-50 rounded-lg transition">
                                            <svg *ngIf="isDeletingId !== cat.id" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                            </svg>
                                            <svg *ngIf="isDeletingId === cat.id" class="w-4 h-4 animate-spin text-rose-600" fill="none" viewBox="0 0 24 24">
                                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Modal Footer (List) -->
            <div class="px-6 py-3 border-t border-gray-100 flex items-center justify-between bg-gray-50 text-xs text-gray-500">
                <span>Total: <strong>{{ filteredCategories.length }}</strong> kategori</span>
                <button (click)="closeModal()" class="px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 hover:bg-gray-100 font-medium transition">
                    Tutup
                </button>
            </div>
        </div>

        <!-- Modal Body: FORM VIEW (ADD / EDIT) -->
        <div *ngIf="viewMode === 'form'" class="flex-1 flex flex-col overflow-hidden">
            <div class="flex-1 overflow-y-auto p-6 space-y-5">
                
                <!-- Name -->
                <div>
                    <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
                        Nama Kategori <span class="text-rose-500">*</span>
                    </label>
                    <input type="text" [(ngModel)]="formName" (input)="onNameChange()" placeholder="Contoh: Support Event, Sales Canvasing"
                        class="w-full px-3.5 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none transition" />
                </div>

                <!-- Color & Sort Order Row -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <!-- Color Picker -->
                    <div>
                        <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
                            Warna Label
                        </label>
                        <div class="flex items-center gap-2">
                            <div class="flex items-center gap-1.5 flex-wrap">
                                <button *ngFor="let col of presetColors" type="button" (click)="selectColor(col)"
                                    class="w-6 h-6 rounded-full border-2 transition-transform transform hover:scale-110 flex items-center justify-center shadow-sm"
                                    [style.backgroundColor]="col"
                                    [class.border-white]="formColor === col"
                                    [class.ring-2]="formColor === col"
                                    [class.ring-gray-800]="formColor === col"
                                    [class.border-transparent]="formColor !== col">
                                    <svg *ngIf="formColor === col" class="w-3.5 h-3.5 text-white drop-shadow" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                            <input type="color" [(ngModel)]="formColor" class="w-8 h-8 rounded-lg cursor-pointer border border-gray-200 p-0.5 bg-white" />
                        </div>
                    </div>

                    <!-- Sort Order & Active Switch -->
                    <div class="grid grid-cols-2 gap-3">
                        <div>
                            <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
                                Urutan
                            </label>
                            <input type="number" [(ngModel)]="formSortOrder" min="0"
                                class="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none transition" />
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
                                Status Aktif
                            </label>
                            <label class="relative inline-flex items-center cursor-pointer mt-2">
                                <input type="checkbox" [(ngModel)]="formIsActive" class="sr-only peer">
                                <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-600"></div>
                                <span class="ml-2.5 text-xs font-medium text-gray-700">
                                    {{ formIsActive ? 'Aktif' : 'Nonaktif' }}
                                </span>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- Description -->
                <div>
                    <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">
                        Deskripsi (Opsional)
                    </label>
                    <textarea [(ngModel)]="formDescription" rows="2" placeholder="Keterangan singkat mengenai kategori voucher ini..."
                        class="w-full px-3.5 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none transition"></textarea>
                </div>

                <!-- Roles Assignment -->
                <div>
                    <div class="flex items-center justify-between mb-2">
                        <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider">
                            Role yang Memiliki Akses (Opsional)
                        </label>
                        <div class="flex items-center gap-2 text-xs">
                            <button type="button" (click)="selectAllRoles()" class="text-emerald-600 hover:underline">Pilih Semua</button>
                            <span class="text-gray-300">•</span>
                            <button type="button" (click)="clearAllRoles()" class="text-gray-500 hover:underline">Hapus Pilihan</button>
                        </div>
                    </div>
                    
                    <div *ngIf="isLoadingRoles" class="py-3 text-xs text-gray-400 flex items-center gap-2">
                        <svg class="w-4 h-4 animate-spin text-emerald-600" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                        </svg>
                        Memuat daftar role...
                    </div>

                    <div *ngIf="!isLoadingRoles && availableRoles.length > 0" class="flex flex-wrap gap-2 p-3 bg-gray-50 rounded-xl border border-gray-200">
                        <label *ngFor="let role of availableRoles"
                            class="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border text-xs font-medium cursor-pointer transition select-none shadow-sm"
                            [ngClass]="isRoleSelected(role.id) ? 'bg-emerald-50 border-emerald-500 text-emerald-800' : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-100'">
                            <input type="checkbox" [checked]="isRoleSelected(role.id)" (change)="toggleRole(role.id)" class="rounded text-emerald-600 focus:ring-emerald-500" />
                            <span>{{ role.name }}</span>
                        </label>
                    </div>
                    <p class="text-[11px] text-gray-400 mt-1">Kosongkan jika kategori ini berlaku untuk semua role pengguna.</p>
                </div>

            </div>

            <!-- Form Footer -->
            <div class="px-6 py-4 border-t border-gray-200 flex items-center justify-end gap-3 bg-gray-50">
                <button type="button" (click)="viewMode = 'list'" [disabled]="isSaving"
                    class="px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 hover:bg-gray-100 text-sm font-medium transition">
                    Batal
                </button>
                <button type="button" (click)="saveCategory()" [disabled]="isSaving"
                    class="px-5 py-2 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-bold rounded-lg transition flex items-center gap-2 shadow-sm disabled:opacity-50">
                    <svg *ngIf="isSaving" class="w-4 h-4 animate-spin text-white" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                    </svg>
                    <span>{{ isSaving ? 'Menyimpan...' : (isEditMode ? 'Perbarui Kategori' : 'Simpan Kategori') }}</span>
                </button>
            </div>
        </div>

    </div>
</div>
